export function calculateProgress(steps) {
    if (!steps || steps["completed"] === true) return 100;
  
    const completedSteps = Object.keys(steps).filter(
      (key) => steps[key].validate === true
    ).length;
  
    const totalSteps = Object.keys(steps).filter(
      (key) => key !== "completed"
    ).length;
  
    return totalSteps > 0 ? (completedSteps / totalSteps) * 100 : 0;
  }